import { Box, Button, Container, Grid, Typography, Card, CardContent, TextField, Avatar, Select, MenuItem, FormControl, InputLabel, InputAdornment, IconButton } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export default function AgencyWithdraw() {
    const [profile, setProfile] = useState(null);
    const [bank, setBank] = useState([]);
    const [money, setMoney] = useState("");
    const [pass, setPass] = useState("");
    const [selectedBank, setSelectedBank] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            }
        );

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setProfile(res.data.data);
                if (res.data.data?._id) {
                    axios.post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: res.data.data._id })
                        .then((resBank) => {
                            if (resBank.data.data) {
                                setBank(resBank.data.data);
                                if (resBank.data.data.length > 0) {
                                    setSelectedBank(resBank.data.data[0]._id);
                                }
                            }
                        }).catch(() => setBank([]));
                }
            })
            .catch(() => setProfile(null));
    }, []);

    const handleWithdraw = async () => {
        if (!money || !pass || !selectedBank) {
            swal("Lỗi", "Vui lòng nhập đầy đủ thông tin", "error");
            return;
        }

        const rawMoney = Number(money.replaceAll(".", "").replaceAll(",", ""));
        if (rawMoney > profile?.money) {
            swal("Lỗi", "Số dư không đủ", "error");
            return;
        }

        if (rawMoney < 500000) {
            swal("Lỗi", "Số tiền rút tối thiểu là 500,000", "error");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/bank/out`, {
                money: rawMoney,
                pass: pass
            });
            if (res.data.success) {
                swal("Thành công", "Đã tạo lệnh rút tiền thành công", "success");
                setMoney("");
                setPass("");
                // Reload profile
                const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
                setProfile(resProfile.data.data);
            } else {
                swal("Lỗi", res.data.message || "Rút tiền thất bại", "error");
            }
        } catch (error) {
            swal("Lỗi", error.response?.data?.message || "Lỗi kết nối", "error");
        }
        setLoading(false);
    };

    const formatMoney = (val) => {
        if (!val) return "";
        let num = val.replace(/\D/g, "");
        return Number(num).toLocaleString("vi-VN");
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout customer={true}>
                <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                    <Container maxWidth="md">
                        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', backgroundColor: '#fff', p: 3, borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                            <Avatar sx={{ width: 60, height: 60, backgroundColor: '#3b82f6', mr: 3 }}>
                                <AccountBalanceWalletIcon fontSize="large" />
                            </Avatar>
                            <Box>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1f2937' }}>Rút tiền</Typography>
                                <Typography variant="body1" sx={{ color: '#6b7280' }}>Tạo lệnh rút tiền về tài khoản ngân hàng của bạn</Typography>
                            </Box>
                        </Box>

                        <Card sx={{ borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ mb: 4, backgroundColor: '#f0fdf4', p: 3, borderRadius: '12px', border: '1px solid #bbf7d0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="h6" sx={{ color: '#16a34a' }}>Số dư khả dụng</Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#16a34a' }}>
                                        {profile?.money?.toLocaleString('vi-VN') || 0} VNĐ
                                    </Typography>
                                </Box>

                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel shrink sx={{ backgroundColor: '#fff', px: 0.5 }}>Ngân hàng nhận tiền</InputLabel>
                                            <Select
                                                value={selectedBank}
                                                label="Ngân hàng nhận tiền"
                                                displayEmpty
                                                onChange={(e) => setSelectedBank(e.target.value)}
                                            >
                                                {bank && bank.length > 0 ? (
                                                    bank.map((b) => (
                                                        <MenuItem key={b._id} value={b._id}>
                                                            {b.name_bank} - {b.stk} - {b.fullname || b.name_user}
                                                        </MenuItem>
                                                    ))
                                                ) : (
                                                    <MenuItem value="" disabled>Chưa liên kết ngân hàng</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Số tiền rút (VNĐ)"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true, sx: { backgroundColor: '#fff', px: 0.5 } }}
                                            value={money}
                                            onChange={(e) => setMoney(formatMoney(e.target.value))}
                                            placeholder="Tối thiểu 500,000"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Mật khẩu rút tiền"
                                            type={showPassword ? "text" : "password"}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true, sx: { backgroundColor: '#fff', px: 0.5 } }}
                                            value={pass}
                                            onChange={(e) => setPass(e.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            size="large"
                                            sx={{ backgroundColor: '#3b82f6', py: 1.5, fontSize: '18px', textTransform: 'none', borderRadius: '8px' }}
                                            onClick={handleWithdraw}
                                            disabled={loading}
                                        >
                                            {loading ? "Đang xử lý..." : "Rút Tiền"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}
